import { Helpers } from '../../helpers';
import { IForecast } from '../../interfaces/iforecast';
import { ForecastHorizontal } from '../forecast-horizontal';
import { ForecastVertical } from '../forecast-vertical';
import { Scenario } from '../scenario';

export class ForecastBase {
  ForecastId: number;
  ScenarioId: number;
  Name: string | null;
  Description: string;
  Created: Date | null;
  Updated: Date | null;
  CreatedBy: string | null;
  UpdatedBy: string | null;

  ForecastHorizontal_Forecast?: Array<ForecastHorizontal> | null;
  ForecastVerticals_Forecast?: Array<ForecastVertical> | null;
  Scenario?: Scenario;

  constructor(item?: IForecast) {
    if (item) {

      this.ForecastId = item.ForecastId;
      this.ScenarioId = item.ScenarioId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_Forecast = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_Forecast);
      this.ForecastVerticals_Forecast = Helpers.createClassArray(ForecastVertical, item.ForecastVerticals_Forecast);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}